module.exports = {
      id: "default-author-image-usage",
      viewBox: "0 0 48 48",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#default-author-image",
      toString: function () {
        return this.url;
      }
    }